module.exports = __webpack_public_path__ + "img/logo.19f298f7.png";